import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface DynamicPopup {
  id: number;
  title: string;
  description?: string;
  external_link?: string;
  active: boolean;
  image: string;
  target_group: string;
  repeat_frequency: number;
  createdAt: string;
  updatedAt: string;
}

export interface DynamicPopupResponse {
  data: DynamicPopup[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

@Injectable({
  providedIn: 'root',
})
export class DynamicPopupService {
  public baseUrl = environment.baseUrl + 'dynamicPopup';

  constructor(private http: HttpClient) {}

  private getHttpOptions(token: string) {
    return {
      headers: new HttpHeaders({
        accessToken: token,
      }),
    };
  }

  getAllDynamicPopup(page: number, limit: number, token: string) {
    return this.http.get<DynamicPopupResponse>(
      `${this.baseUrl}/getAllDynamicPopup?page=${page}&limit=${limit}`,
      this.getHttpOptions(token)
    );
  }

  getDynamicPopup(id: number | string, token: string) {
    return this.http.get<DynamicPopup>(
      `${this.baseUrl}/getDynamicPopup?id=${id}`,
      this.getHttpOptions(token)
    );
  }

  createDynamicPopup(payload: FormData, token: string) {
    return this.http.post(
      `${this.baseUrl}/createDynamicPopup`,
      payload,
      this.getHttpOptions(token)
    );
  }

  updateDynamicPopup(
    id: number | string,
    payload: FormData | object,
    token: string
  ) {
    // Handling cases where backend might expect ID in URL or Body, assuming URL based on standard REST,
    // but user prompt mentioned "or current backend route if no :id, then include id in body/query"
    // We will try standard REST first: PATCH /updateDynamicPopup/:id
    // If specifically requested to use query param for update, we can adjust.
    // Based on user request: PATCH admin/dynamicPopup/updateDynamicPopup/{id}
    return this.http.patch(
      `${this.baseUrl}/updateDynamicPopup/${id}`,
      payload,
      this.getHttpOptions(token)
    );
  }

  deleteDynamicPopup(id: number | string, token: string) {
    return this.http.delete(
      `${this.baseUrl}/deleteDynamicPopup/${id}`,
      this.getHttpOptions(token)
    );
  }
}
